import {
  CREATE_PRINT_QR_START,
  CREATE_PRINT_QR_SUCCESS,
  CREATE_PRINT_QR_FAILURE,
  GET_PRINT_QR_LIST_START,
  GET_PRINT_QR_LIST_SUCCESS,
  GET_PRINT_QR_LIST_FAILURE,
} from "../types/printQRTypes";

import { createPrintQR, getPrintQRList } from "../../services/PrintQRService";
import {
  handleSuccess,
  showErrorAlert,
} from "../../services/ErrorHandlingService";

// =======================
// Create Print QR
// =======================
export function createPrintQRAction(payload) {
  return async (dispatch) => {
    try {
      dispatch({ type: CREATE_PRINT_QR_START });

      const response = await createPrintQR(payload);

      if (response?.status === 200) {
        dispatch({
          type: CREATE_PRINT_QR_SUCCESS,
          payload: response.data,
        });

        handleSuccess(response.data?.message || "QR codes generated successfully!");
        
        return response;
      }
    } catch (error) {
      console.error("Create print QR error:", error);

      dispatch({
        type: CREATE_PRINT_QR_FAILURE,
        payload: error?.response?.data || error.message,
      });

      showErrorAlert(error?.response?.data?.message || "Failed to generate QR codes");
      throw error;
    }
  };
}

// =======================
// Get Print QR List
// =======================
export function getPrintQRListAction() {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_PRINT_QR_LIST_START });

      const response = await getPrintQRList();

      if (response?.status === 200) {
        dispatch({
          type: GET_PRINT_QR_LIST_SUCCESS,
          payload: response.data,
        });
        // Don't show success toast on page load
        return response;
      }
    } catch (error) {
      console.error("Get print QR list error:", error);

      dispatch({
        type: GET_PRINT_QR_LIST_FAILURE,
        payload: error?.response?.data || error.message,
      });

      showErrorAlert(error?.response?.data?.message || "Failed to fetch QR code list");
      throw error;
    }
  };
}